






import { Component, Vue, Prop } from "vue-property-decorator"

@Component
export default class Loading extends Vue {
  @Prop(String) private msg?: string

  display = false

  show() {
    this.display = true
  }

  hide() {
    this.display = false
  }
}
